<template>
  <div class="button" @click.prevent="followingByLink">{{ title }}</div>
</template>
<script>
import transformDatToData from '@/mixin/transform_dat_to_data'

export default {
  mixins: [transformDatToData],
  data() {
    return {
      url: '',
      title: ''
    }
  },
  methods: {
    followingByLink() {
      location.href = this.targetUrl
    }
  },
  computed: {
    targetUrl() {
      let baseUrl = `${location.protocol}//${location.host}/`
      let path = this.url

      if (path[0] === '/')
        path = path.slice(1)

      return `${baseUrl}${path}`
    }
  }
}
</script>